export const navigationLinks = [
   { name: 'Home', href: '/' },
   { name: 'Blog', href: '/blog' },
   { name: 'About', href: '/about' },
   { name: 'Gallery', href: '/portfolio' },
   { name: 'Films', href: '/videography' },
   { name: 'Pricing', href: '/packages' },
   { name: 'Book Me', href: '/book-me' },
];
